
function parseJSON(response) {
  return response.json()
}


function getCurrentUser() {
  return fetch('/laskuri/localapi/user/current', {
    credentials: 'same-origin'
  }).then(parseJSON)
}



export default {
  getCurrentUser
}



// WEBPACK FOOTER //
// ./src/api/userService.js